import React from 'react';
import PropTypes from 'prop-types';

import CardLink from '../components/CardLink';
import {useUser} from '../utils/UserSession';
import {shouldShowDocenteSectionChoice, SECTION_SELECTED_KEY} from '../utils/membershipUi';

const Dashboard = () => {
  const {user} = useUser();

  if (shouldShowDocenteSectionChoice(user)) {
    return (
      <main className="gc-wrap gc-wrap--page">
        <div className="gc-sc-cardgrid gc-sc-cardgrid--2col">
          <CardLink
            to="/grp-docenti"
            text="Profilo accompagnatore"
            description="Accompagnerai i tuoi studenti per una magnifica esperienza insieme. Monitora le prenotazioni e le info aggiornate dei partecipanti."
            eyebrow="Ruolo · Partner"
            icon="School"
            tier="blue"
            tall
            onClick={() => localStorage.setItem(SECTION_SELECTED_KEY, 'docente')}
          />
          <CardLink
            to="/dashboard"
            text="Profilo cliente"
            description="Accedi all'area cliente con tutte le tue prenotazioni, i voucher accumulati e i vantaggi del Club Giocamondo."
            eyebrow="Ruolo · Cliente Club"
            icon="Member"
            tier="gold"
            tall
            onClick={() => localStorage.setItem(SECTION_SELECTED_KEY, 'member')}
          />
        </div>
      </main>
    );
  }

  return (
    <main className="gc-wrap gc-wrap--page-tight">
      <div className="gc-band">
        <div className="gc-band__title"><h2>Le tue sezioni</h2><span className="gc-band__rule" /></div>
        <span className="gc-band__count">4 aree</span>
      </div>

      <div className="gc-sc-cardgrid gc-sc-cardgrid--4col">
        <CardLink to="/account"   text="Informazioni account"   eyebrow="Sezione · Profilo"      tier="blue"    />
        <CardLink to="/practices" text="Le mie prenotazioni"    eyebrow="Sezione · Pratiche"     tier="silver"  />
        <CardLink to="/payments"  text="Pagamenti e fatture"    eyebrow="Sezione · Contabilità"  tier="gold"    />
        <CardLink to="/documents" text="Contratti e documenti"  eyebrow="Sezione · Documenti"    tier="diamond" />
      </div>

      <div className="gc-band gc-band--spaced-top">
        <div className="gc-band__title"><h2>Vantaggi del club</h2><span className="gc-band__rule" /></div>
        <span className="gc-band__count">2 servizi</span>
      </div>

      <div className="gc-grid--cards-2">
        <div className="gc-card2 gc-card2--hover">
          <div className="gc-card2__head gc-card2__head--gold">
            <span className="gc-iconbadge gc-iconbadge--gold">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
              </svg>
            </span>
            <div>
              <p className="gc-card2__eyebrow">Riservato · Silver+</p>
              <h3 className="gc-card2__title">Lesson Live · Inglese</h3>
            </div>
          </div>
          <div className="gc-card2__body">
            <p className="gc-card2__lead">
              Lezioni one-to-one ed esami di certificazione linguistica riconosciuti dal MIUR, riservati ai membri Silver e superiori.
            </p>
            <a className="tmp-glink tmp-glink--gold" href="/onetoone">Scopri di più</a>
          </div>
        </div>

        {/* Card "Giocamondo Store" temporaneamente rimossa
        <div className="gc-card2 gc-card2--hover">
          <div className="gc-card2__head gc-card2__head--petrolio">
            <span className="gc-iconbadge gc-iconbadge--petrolio">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
              </svg>
            </span>
            <div>
              <p className="gc-card2__eyebrow">Per tutti i livelli</p>
              <h3 className="gc-card2__title">Giocamondo Store</h3>
            </div>
          </div>
          <div className="gc-card2__body">
            <p className="gc-card2__lead">
              Continua i tuoi acquisti con i gadget, i libri e le t-shirt targati Giocamondo, in esclusiva per i soci del Club.
            </p>
            <a className="tmp-glink tmp-glink--gold" href="/store">Vai allo Store</a>
          </div>
        </div>
        */}
      </div>
    </main>
  );
};

Dashboard.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
};

export default Dashboard;
